// UI/ToggleButton/AutoTransmission.tsx
import './toggle.css';
import React from 'react';

interface AutoTransmissionProps {
    toggle: boolean;
    handleToggleChange: () => void;
    children?: React.ReactNode; // Make children optional
}

export const automat = <span className='categoryRegist'>Automat</span>;
export const manuell = <span className='categoryRegist'>Automat</span>;

export const AutoTransmission: React.FC<AutoTransmissionProps> = ({ toggle, handleToggleChange, children }) => {
    return (
        <div onClick={handleToggleChange}>
            <div className={`toggle-btn ${!toggle ? 'disable' : ''}`}>
                {toggle ? automat : manuell}
                {children} {/* Render the children here */}
            </div>
        </div>
    );
};